import { concatBasePathWithPath } from 'common/router/utils';
import {
  CharityVettingUrlType,
  type CharityVettingUrlTypeValues,
} from 'features/charity-vetting/types/charityVettingTypes';
import { FormattedMessage } from 'react-intl';

import msg from '../../common-flow/components/navigation-bar/messages';
import { vettingPath } from '../../common-flow/entries/path';
import { commonNavigationItems } from '../../utils/commonNavigationHandlers';
import { type StepName } from '../../utils/formHandlers';

import { FR_DECLARATIONS } from './components/steps/declaration-step/frDeclarations';
import { FR_DOCUMENTS } from './frDocuments';

import type { CharityVettingNavigationItem } from '../../utils/navigationTypes';

export const frNavigationItems: CharityVettingNavigationItem[] = [
  {
    ...commonNavigationItems.search,
  },
  {
    stepLabel: <FormattedMessage {...msg.charityVettingNavItemOrganisationInformation} />,
    id: CharityVettingUrlType.REGISTRATION_DETAILS as StepName,
    isCompleted: false,
    isActive: false,
    urlTypeId: [
      'authorised-food-aid',
      'organisation-purpose',
      'organisation-specific-type',
      'decree-publication-dates',
      'arrete-publication-date',
      'organisation-situation',
      'organisation-other-option',
      'agrement-date',
      'siren',
    ] as CharityVettingUrlTypeValues[],
    stepPathUrl: concatBasePathWithPath(vettingPath.authorisedFoodAidPath, vettingPath.basePath),
  },
  {
    stepLabel: <FormattedMessage {...msg.charityVettingNavItemDonationPreferences} />,
    id: CharityVettingUrlType.DONATION_PREFERENCES as StepName,
    isCompleted: false,
    isActive: false,
    urlTypeId: [
      'donation-preferences',
      'accept-all-foods',
      'accept-all-non-food',
      'accept-all-food-and-non-food',
      'unwanted-food',
    ],
    stepPathUrl: concatBasePathWithPath(vettingPath.donationPreferencesPath, vettingPath.basePath),
  },
  {
    stepLabel: <FormattedMessage {...msg.charityVettingNavItemFoodSafety} />,
    id: CharityVettingUrlType.FOOD_SAFETY_QUESTION_THREE as StepName,
    isCompleted: false,
    isActive: false,
    urlTypeId: [
      'food-safety-question-three',
      ...FR_DECLARATIONS.map((declaration) => declaration.segment),
    ],
    stepPathUrl: concatBasePathWithPath(vettingPath.foodSafetyQThreePath, vettingPath.basePath),
  },
  {
    stepLabel: <FormattedMessage {...msg.charityVettingNavItemDocuments} />,
    id: CharityVettingUrlType.ASSOCIATION_REGISTRATION,
    isCompleted: false,
    isActive: false,
    urlTypeId: FR_DOCUMENTS.map((document) => document.segment),
    stepPathUrl: concatBasePathWithPath(
      vettingPath.associationRegistrationPath,
      vettingPath.basePath,
    ),
  },
  {
    ...commonNavigationItems.socialAccounts,
  },
  {
    ...commonNavigationItems.reviewDetails,
  },
];
